export default class OperationCanceledError extends Error {}